<script>
    import { ValueService } from '../../services/ValueService.js';

    /**
     * @type {{
     *     tag?: string,
     *     show_id?: number | string | null,
     *     name?: boolean,
     * }}
     */
    let { tag = 'span', show_id = 0, name = true } = $props();
    const thisShowId = $derived(ValueService.toUInt(show_id));
</script>

<span class="text-black-o500 font-mono text-sm font-normal">
    {#if thisShowId === 0}
        <span class="text-error-200">-</span>
    {:else}
        #{thisShowId}
    {/if}
</span>
